import React from 'react';
import { Zap } from 'lucide-react';
import { TRUST_BADGES } from './summerCampContent';
export function SummerCampTrustBar() {
  return <section className="bg-charcoal py-6 border-y border-storm-red/20" data-id="element-3294">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3295">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-3296">
          {TRUST_BADGES.map((badge, idx) => <div key={idx} className="flex items-center gap-2 text-white text-sm font-bold" data-id="element-3297">
              <Zap className="w-4 h-4 text-storm-red" fill="currentColor" data-id="element-3298" />
              <span className="uppercase tracking-wide" data-id="element-3299">{badge}</span>
            </div>)}
        </div>
      </div>
    </section>;
}